import { useEffect, useState } from 'react';
import _ from 'lodash';
import { getHighlightColors } from 'common/constants/_colors';
import { METRICS, TRACKING } from 'common/constants/constants';
import { checkStatusChanges } from '../services/projects.services';
import {
  CUSTOM_DEFAULT_END_DATE,
  CUSTOM_DEFAULT_START_DATE,
  SUMMARY_PERIODS_DEFAULT
} from '../projects.consts';
import * as TrackingService from 'common/services/tracking.service';
import QueryString from 'query-string';
import useFetchPdtProjctsData from './useFetchPdtProjctsData';

export const useProjects = ({ account }) => {
  const [favoriteProjectsCount, setFavoriteProjectsCount] = useState(
    account?.settings?.favorite_projects?.length
  );

  const search = QueryString.parse(window.location.search, {
    ignoreQueryPrefix: true
  });
  const [selectedPeriod, setSelectedPeriod] = useState(
    _.get(search, 'duration_filter', SUMMARY_PERIODS_DEFAULT)
  );

  const [selectedTimeRange, setSelectedTimeRange] = useState({
    start_date: _.get(search, 'start_date', CUSTOM_DEFAULT_START_DATE),
    end_date: _.get(search, 'end_date', CUSTOM_DEFAULT_END_DATE)
  });

  const {
    projects,
    setProjects,
    totalProjects,
    isLoadingLightData,
    allProjectsTotal,
    paginationHandler,
    keyword,
    setKeyword,
    emptyStateType,
    isDataFetchedByProjectId
  } = useFetchPdtProjctsData({
    selectedPeriod,
    timeRange: selectedTimeRange
  });

  useEffect(() => {
    if (selectedPeriod) {
      TrackingService.logEvent(TRACKING.EVENTS.FILTER, {
        page: TRACKING.PAGES.PROJECTS,
        filter_name: TRACKING.FILTER.PROJECT_TIME,
        filter_value: selectedPeriod
      });
    }
  }, [selectedPeriod]);

  useEffect(() => {
    const interval = checkStatusChanges({
      projects,
      onChange: mapResult =>
        setProjects([...projects].map(item => mapResult[item.id] || item)),
      selectedPeriod
    });
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [projects]);

  const SUMMARY = [
    {
      name: 'Projects',
      icon: 'Projects',
      value: allProjectsTotal || 0
    },
    {
      name: 'People',
      icon: 'TeamsPeopleIcon',
      value: _.get(projects, '[0].total_contributors')
    }
  ];

  const getInvestmentColorsMap = () => {
    const investmentColors = getHighlightColors().filter(
      c => c !== METRICS.BUG_COLOR
    );
    const investmentKeys = {};
    projects
      .map(({ total_investment_counts }) => total_investment_counts || {})
      .forEach(total => {
        Object.entries(total).forEach(([key, value]) => {
          investmentKeys[key] =
            (!investmentKeys[key] ? 0 : investmentKeys[key]) + value;
        });
      });
    const investmentColorsMap = [];
    Object.keys(investmentKeys)
      .filter(item => _.startCase(item) !== METRICS.BUG_STATE)
      .sort((a, b) => investmentKeys[a] - investmentKeys[b])
      .reverse()
      .forEach((key, idx) => {
        investmentColorsMap[key] = investmentColors[idx];
      });
    investmentColorsMap[_.toLower(METRICS.BUG_STATE)] = METRICS.BUG_COLOR;
    return investmentColorsMap;
  };

  return {
    projects,
    setProjects,
    favoriteProjectsCount,
    setFavoriteProjectsCount,
    selectedPeriod,
    setSelectedPeriod,
    SUMMARY,
    investmentColorsMap: getInvestmentColorsMap(),
    loading: isLoadingLightData,
    selectedTimeRange,
    setSelectedTimeRange,
    paginationHandler,
    totalProjects,
    keyword,
    setKeyword,
    emptyStateType,
    isDataFetchedByProjectId
  };
};
